import {
  CONNECTION_STATUS_OPTIONS,
  ConnectionStatus,
} from './retailer-network-my-stores-v2-page.types';

export const FILTER_PARAM_NAMES = {
  state: 'state',
  city: 'city',
  connectionStatus: 'connectionStatus',
  search: 'search',
} as const;

export const isValidConnectionStatus = (value: string | null): value is ConnectionStatus =>
  CONNECTION_STATUS_OPTIONS.includes(value as ConnectionStatus);

// Any active filter or search switches the page from the grouped location-group cards to a
// single flat list of matching locations (no group headers) — shared by the page component
// (which decides what to render) and the container (which skips the location-groups query
// entirely when the grouped view won't be shown).
export const hasActiveFilterOrSearch = ({
  stateFilter,
  cityFilter,
  connectionStatusFilter,
  search,
}: {
  stateFilter: string;
  cityFilter: string;
  connectionStatusFilter: ConnectionStatus | '';
  search: string;
}): boolean => Boolean(stateFilter || cityFilter || connectionStatusFilter || search.trim());
